import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ContractRenderer from "./ContractRenderer";

const ContractList = ({ contracts, onContractSelect, currentUser }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredContracts, setFilteredContracts] = useState(contracts);

  // Filter contracts based on search term
  useEffect(() => {
    const filtered = contracts.filter(contract =>
      contract.contractCode.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredContracts(filtered);
  }, [contracts, searchTerm]);

  return (
    <div>
      <div className="field field--stacked">
        <input
          type="text"
          className="fullwidth"
          placeholder="Search contracts..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <ul className="list">
        {filteredContracts.map(contract => (
          <li key={contract.id} className="list__item">
            <ContractRenderer
              contract={contract}
              onClose={onContractSelect}
              currentUser={currentUser}
              background={false}
            />
          </li>
        ))}
      </ul>
      {searchTerm && filteredContracts.length === 0 && (
        <div>
          No contracts found matching "{searchTerm}"
        </div>
      )}
    </div>
  );
};

ContractList.propTypes = {
  contracts: PropTypes.array.isRequired,
  onContractSelect: PropTypes.func.isRequired,
  currentUser: PropTypes.object
};

export default ContractList;
